import { Grid, Stack, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import VegaText from './VegaText';

type Props = {
  title?: string;
  renderLeftView?: () => ReactNode;
  renderRightView?: () => ReactNode;
  sx?: SxProps<Theme>;
};
function VegaPageHeader({ title, renderLeftView, renderRightView, sx }: Props) {
  const defaultSxStyles = {
    paddingTop: '1.25rem',
    paddingRight: '1.5rem',
    paddingBottom: '1.25rem',
    paddingLeft: '1.5rem',
    borderBottom: '1px solid #DBDBDB',
    bgcolor: '#FAFAFA',
    minHeight: '4rem',
  };

  const mergedSxStyles = { ...defaultSxStyles, ...sx };

  return (
    <Grid
      container
      justifyContent={'space-between'}
      alignItems="start"
      sx={mergedSxStyles}
    >
      <Grid item>
        <Stack direction={'row'} alignItems="center">
          {title && (
            <VegaText
              text={title}
              fontWeight={600}
              fontSize={'1.0625rem'}
              color={'black'}
            />
          )}
          {renderLeftView?.()}
        </Stack>
      </Grid>
      <Grid item>{renderRightView?.()}</Grid>
    </Grid>
  );
}

export default VegaPageHeader;
